// link
import { NavLink } from "react-router-dom";
// @ts-ignore
import Cookies from "js-cookie";
import { IconUser } from "@tabler/icons-react";

const MobileNav = (props: object | any) => {
    return (
        <>
            <section className="d-md-none d-inline-block mobile-menu d-flex justify-content-center position-relative">
                <div
                    className="header-mobile fixed-bottom py-2 d-md-none d-inline-block position-fixed shadow shadow-lg">
                    <div className="px-2">
                        <div className="d-flex align-items-center justify-content-between">
                            {props.routes.map((link: object | any, index: number) => (
                                <>
                                    {link.child ? (
                                        <>
                                            <div key={link.address} className={link.mobileShow ? 'btn-phone d-flex justify-content-center p-0 mx-1 text-blue' : 'd-none'}>
                                                <div
                                                    data-bs-toggle={link.toggle} data-bs-target={link.mobaddress}>
                                                    <div className="activator d-flex justify-content-center align-items-center">
                                                        <button className="btn btn-outline-site p-0">
                                                            {link.icon}
                                                        </button>
                                                    </div>
                                                    <p className="text-center mb-0 mt-3">
                                                        {link.label}
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div key={link.address} className={link.mobileShow ? 'btn-phone d-flex justify-content-center p-0 mx-1 text-blue' : 'd-none'}>
                                                <NavLink className={'text-decoration-none'}
                                                    to={link.address}>
                                                    <div className="activator d-flex justify-content-center align-items-center">
                                                        <button className="btn btn-outline-site p-0">
                                                            {link.icon}
                                                        </button>
                                                    </div>
                                                    <p className="text-center mb-0 mt-3">
                                                        {link.label}
                                                    </p>
                                                </NavLink>
                                            </div>
                                        </>
                                    )}
                                </>
                            ))}
                            {Cookies.get('agent_token') ? (
                                <>
                                    <div className={'btn-phone p-0 mx-1 text-blue'}>
                                        <NavLink to={'/user/profile'} className={'text-decoration-none'}>
                                            <div className="activator d-flex justify-content-center align-items-center">
                                                <button className="btn btn-outline-site p-0">
                                                    <IconUser />
                                                </button>
                                            </div>
                                            <p className="text-center mb-0 mt-3">
                                                پنل کاربر
                                            </p>
                                        </NavLink>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={'btn-phone d-flex justify-content-center p-0 mx-1 text-blue'}>
                                        <div
                                            data-bs-toggle={'modal'} data-bs-target={'#agent'}>
                                            <div className="activator d-flex justify-content-center align-items-center">
                                                <button className="btn btn-outline-site p-0 mb-0">
                                                    <IconUser />
                                                </button>
                                            </div>
                                            <p className="text-center mb-0 mt-3">
                                                ورود
                                            </p>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MobileNav;